module.exports = __webpack_public_path__ + "3fad5d0e5a0665c521936f2686f06bf7.png";